// import React from 'react';
// import { Link, useHistory } from "react-router-dom"
// import { COLOR_GREENISH } from '../../utils/constants';
// import styles from './styles'
// import logo from '../../res/logo.png'
// import { Image } from "react-bootstrap"

// export default function TermsOfService() {

// const privacyLink = <Link to="/privacy-policy" target={'blank'} style={{display: 'inline-block'}}>
//                     <p style={{margin: 0, fontWeight: 'bold'}}>Privacy Policy</p>
//                   </Link>
// const privacyLinkQuotes = <Link to="/privacy-policy" target={'blank'} style={{display: 'inline-block'}}>
// <p style={{margin: 0, fontWeight: 'bold'}}>(the “Privacy Policy”)</p>
// </Link>
// const adminSiteLink = <Link to="/" target={'blank'} style={{display: 'inline-block'}}>
// <p style={{margin: 0, fontWeight: 'bold'}}>http://equine-exchange.com</p>
// </Link>


//   return (
//     <>
//       <h1 
//         style={{ 
//             color: COLOR_GREENISH, 
//             textAlign: 'center', 
//             marginTop: 50}}
//        >
//         EQUINE EXCHANGE
//       </h1>
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           height: '100%',
//           width: '100%',
//           paddingLeft: 25,
//           paddingRight: 25,
//           justifyContent: 'center',
//           background: '#fff',
//           flexDirection: 'column',
//         }}
//       >
//         <Image src={logo} rounded width='200'
//                                 height='200'
//                                 className="d-inline-block align-top"/>

//         <p style={styles.pageTitle}>TERMS OF SERVICE</p>
        
//         <p style={styles.text}>
//         This Terms of Service (“Agreement”) is a legally binding agreement between you (“User”, “you” or “your”) andEquine Exchange, LLC (“Equine Exchange ", "we", "us" or "our") , and governs your access and use of the Equine Exchange mobile application, any related web presence(s), updates, documentation and all content, products and services (“Services”) provided or viewed by or through any of the foregoing (collectively, the “Mobile App”). It includes important information about your legal rights, and covers areas such as automatic subscription renewals, warranty disclaimers, limitations of liability, governing law and venue, and a class action waiver.  The Mobile App is being provided to you subject to all of the terms and conditions of this Agreement and Our {privacyLink}.  Without limiting the foregoing, we and our licensors retain all rights, title and interests in and to the Mobile App.
//         </p>
//         <p style={styles.textBold} className={'liiii'}>
//         BY CLICKING THE “I ACCEPT” BUTTON OR BY ACCESSING OR USING THE MOBILE APP OR ANY SERVICES, YOU ACKNOWLEDGE AND AGREE THAT YOU HAVE REVIEWED, UNDERSTOOD AND AGREED TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.  IF YOU DO NOT AGREE TO BE BOUND BY ALL OF THE TERMS OF THIS AGREEMENT (OR IF YOU ARE YOUNGER THAN 13 YEARS OF AGE), CLICK THE “DECLINE” BUTTON AND DO NOT FURTHER ACCESS OR USE THIS MOBILE APP OR ANY SERVICES.BY CLICKING THE "I ACCEPT" BUTTON OR BY ACCESSING OR USING THE MOBILE APP OR ANY SERVICES, YOU FURTHER INDICATE THAT YOU INTEND YOUR ACT TO SERVE AS YOUR SIGNATURE TO THIS AGREEMENT AND TO HAVE THE SAME FORCE AND EFFECT AS THE USE OF A MANUAL SIGNATURE, AND IF YOU ARE ACCESSING OR USING THE MOBILE APP OR ANY SERVICES IN YOUR CAPACITY AS AN EMPLOYEE OR AGENT OF A BUSINESS ENTITY, YOU WARRANT THAT YOU HAVE ACTUAL AUTHORITY TO LEGALLY BIND SUCH ENTITY TO THIS AGREEMENT.
//         </p>
//         <div>
//             <ol type={1} style={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column'}}>
                
//                 <li style={styles.li}>
//                     <p style={styles.textBold}>General</p>
//                     <ol type={'a'}>
//                         <li style={{display: 'inline'}}/> 
//                         <li style={styles.li}>
                            
//                                 <b>Your Responsibilities.</b> You are solely responsible for: (a) your selection and use of the Mobile App for your purposes, including all of its features and functionality; (b) any content you generate or otherwise utilize via the Mobile App, including as to any products or services offered by or consumed by you <b>(“Your Content”); </b>                            and (c) any consequences of or associated with any of the foregoing.  Do not copy, upload, or share content unless you are confident you have the necessary rights to do so. We are not responsible for the conduct of, or content (including Your Content) provided by, you or of any other user of the Mobile App.
                            
//                         </li>
//                         <li style={styles.li}>
                            
//                                 <b>Signing Up. </b>To use many parts of the Mobile App and Services, you must first create an account <b>(“Account”). </b>Different parts of the Services may require different Accounts. You agree to provide us with accurate, complete and at all times up to date information for your Accounts. We may need to use this information to contact you.
                            
//                         </li>
//                         <li style={styles.li}>
                            
//                                 <b>Safeguards. </b>Please safeguard your Account and make sure others do not have access to your Account or passwords and other authentication credentials (collectively, “passwords”). You are solely responsible for any activity on your Account and for maintaining the confidentiality and security of your passwords. We are not liable for any acts or omissions by you or anyone else in connection with your Account. You must immediately notify us if you know or have any reason to suspect that your Account or passwords have been stolen, misappropriated or otherwise compromised or in case of any actual or suspected unauthorized use of your Account.
                            
//                         </li>
//                     </ol>
//                 </li>
//                 <li style={styles.li}>
//                     <p style={styles.textBold}>Limited License to You.</p>
//                     <ol type={'a'}>
//                         <li style={{display: 'inline'}}/> 
//                         <li style={styles.li}>
                            
//                                 <b>License Grant.</b> Subject to your continued compliance with all of the terms of this Agreement, we grant you a limited, non-exclusive, personal, non-transferable, revocable, license <b>(the “License”)</b> to access, stream, download and install the Mobile App on a personal computing device or mobile phone that you own or control <b>(a “Mobile Device”)</b>, and to use the Mobile App, and its various features and functionality, solely as permitted and intended by the Mobile App, and solely for your personal, non-commercial use, as further outlined herein.
                            
//                         </li>
//                         <li style={styles.li}>
//                             <p>
//                              <b>License Restrictions.</b> You will not, and you will not permit or assist any other person or entity to:
//                             </p>
//                              <ol type={'i'}>
//                                 <li style={{display: 'inline'}}/> 
//                                 <li style={styles.li}>copy the Mobile App or related content or documentation, in whole or in part;</li>
//                                 <li style={styles.li}>modify, translate, adapt, or otherwise create derivative works or improvements of the Mobile App;</li>
//                                 <li style={styles.li}>remove, delete, alter, or obscure any trademarks or any copyright, trademark, patent or other intellectual property or proprietary rights notices from the Mobile App; </li>
//                                 <li style={styles.li}>transmit, access, or communicate any data or material (including, without limitation, Your Content) that infringes any patent, trademark, trade secret, copyright, publicity right, privacy right, or other proprietary right of ours or any other person; </li>
//                                 <li style={styles.li}>rent, lease, lend, use for timesharing, service bureau, sell, sublicense, assign, distribute, publish, transfer or otherwise make available the Mobile App or any features or functionality of the Mobile App, including, without limitation, any content, to any third party for any reason, including by making the Mobile App available on a network where it is capable of being accessed by more than one device at any time; </li>
//                                 <li style={styles.li}>reverse engineer, decompile, disassemble, decode or otherwise attempt to derive or gain access to all or any part of the source code of the Mobile App and/or any content available through the Mobile App; </li>
//                                 <li style={styles.li}>impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity; </li>
//                                 <li style={styles.li}>send, allow access to, or otherwise provide to anyone any obscene, pornographic or other age-inappropriate content or materials; </li>
//                                 <li style={styles.li}>forge headers or otherwise manipulate or modify identifiers in order to disguise the origin of any transmissions; </li>
//                                 <li style={styles.li}>transmit, access, view or communicate any data that you do not have a right to transmit;</li>
//                                 <li style={styles.li}>interfere with or disrupt any other person’s rightful use of the Mobile App;</li>
//                                 <li style={styles.li}>violate local, state, national or international law, rules, regulations, executive orders or policies relating to the use of the Mobile App;</li>
//                                 <li style={styles.li}>knowingly transmit, access, or communicate any data that contains software viruses or any other malicious computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or hardware or tele-communications equipment; or</li>
//                                 <li style={styles.li}>monitor traffic or make search requests in order to accumulate information about individual users of the Mobile App.</li>
//                              </ol>
                            
//                         </li>
//                         <li style={styles.li}>
//                         You hereby acknowledge and agree that Equine Exchange reserves the rights, but undertakes no obligation, to remove any content (e.g., images, video), Services, Third Party Materials (defined below) or other materials provided or viewed by or through the Mobile App, in Equine Exchange’s sole discretion and without notice to you.
//                         </li>
//                     </ol>
//                 </li>
//                 <li style={styles.li}>
//                     <b>License to Equine Exchange.</b> You hereby freely and irrevocably grant to Equine Exchange, our affiliates and our and their successor or assigns, a nonexclusive, fully paid-up, royalty-free, perpetual, irrevocable, unlimited, worldwide right and license to, directly or indirectly, make, have made, copy, modify, create derivative works of, publicly display, perform, publish, use, and otherwise distribute and/or utilize any information, content (e.g., images, video) or other material, including, without limitation, Your Content, that you submit to the Mobile App or otherwise provide or make accessible using the Mobile App, and for Equine Exchange to authorize others to do any of the foregoing via a sublicense, subject only to the express limitations in this Agreement and in the {privacyLink} discussed below.  Without limiting the foregoing, you acknowledge and agree that Equine Exchange reserves the right, but undertakes no obligations, to modify, delete or remove, delete Your Content, in whole or in part, in our sole discretion, including, without limitation, for any violation of the restrictions of your limited License (see Section 2(b) above).   Any feedback, comments, proposed improvements or modifications or other suggestions you may provide regarding the Mobile App is entirely voluntary and Equine Exchange will be free to use such feedback, proposed improvements, modifications, comments or suggestions as it sees fit without any obligation or
//                 </li>
//                 <li style={styles.li}>
//                     <b>Collection and Use of Your Information; Technical Information.</b> Our collection and use of content you generate, upload, submit or otherwise provide in connection with your access, streaming, downloading, installing, posting or any use of the Mobile App, including Your Content, is described in the Privacy Policy {privacyLinkQuotes}. By accessing, streaming, downloading, installing, posting or otherwise using in any way the Mobile App or any of the Services, you consent to the Privacy Policy.
//                 </li>
//                 <li style={styles.li}>
//                     <b>Retention Policy</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}>We reserve the right, but undertakes no obligation, to retain indefinitely any information you generate or otherwise make accessible in connection with the Mobile App, including any of Your Content, along with any basic profile/personal information, your transactions, Mobile Device information and other information outlined in the Privacy Policy, in our sole discretion.  Without limiting the foregoing, we also reserve the right, but undertakes no obligations, to delete such materials and any accompanying information.  Please note this voluntary retention policy is subject to change to accommodate our current storage capacity and processing abilities without any notice to you.</li>
//                         <li style={styles.li}>Notwithstanding Section 5(a) above, we are not responsible or otherwise liable for the loss of, deletion of, unauthorized access to, or the failure to store or otherwise protect any of Your Content or information. You are encouraged to keep an alternative back-up copy of any of Your Content and/or other information, if retaining a copy is important to you.</li>
//                     </ol>
//                 </li>
//                 <li style={styles.li}><b>Geographic Restrictions.</b>  The Mobile App is intended for use by persons only while located within the United States of America, its territories and possessions (collectively, the <b>“United States”</b>). The Mobile App may not comply with the laws of other countries or jurisdictions. If you access or use the Mobile App while outside the United States, you are solely responsible for complying with all applicable local laws.</li>
//                 <li style={styles.li}><b>Updates.</b>  We may, but undertake no obligations to, at any time add, remove, change or other modify features and/or functionality of the Mobile App, including, without limitation, certain content and/or any Services, through the use of bug fixes, patches and other updates (the <b>“Updates”</b>), with no notice to you.  Based on your Mobile Device settings, for any such Updates when your Mobile Device is connected to the internet either: (a) the Mobile App will automatically download and install all available Updates; or (b) you may receive notice of or be prompted to download and install available Updates. If you do not promptly download and install all Updates, the Mobile App may not operate properly.</li>
//                 <li style={styles.li}>
//                     <b>Third Party Sites, Services and Materials.</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}><b>Third Party Materials.</b>  The Mobile App may display, include or otherwise make available third-party content (including, without limitation, property, images, data, information, applications and other products services and/or materials) or provide links to third-party websites or services, including through third-party advertising <b>(“Third Party Materials”)</b>, such as Twitter or other social media sources.  We are not responsible for any Third Party Materials or their sources, including, without limitation, their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect.  We do not assume and will not otherwise have any liability or responsibility to you or to any other person or entity for any Third Party Materials.  Third Party Materials and any links to Third Party Materials are provided solely as a convenience and courtesy to you and you access and use them at entirely your own risk and subject to the third parties’ applicable terms and conditions.</li>
//                         <li style={styles.li}><b>Third Party Services.</b> You may be provided with various third party services and applications (collectively, <b>“Third Party Services”</b>) via the Mobile App that may make their content, products or services available to you. Examples of Third Party Services include e-commerce payment processors and other integration partners and service providers. These Third Party Services may have their own terms and policies, and your use of them will be governed by those terms and policies. Any information that a Third Party Service collects, stores and processes from you will be subject to such Third Party Service’s terms of service, privacy notice, or similar terms, and will not be subject to our {privacyLink}. Therefore, please evaluate and ensure you trust each Third Party Service prior to interacting or providing any information with same. Each Third Party Service is solely responsible for providing all support, maintenance and technical assistance to you with respect to their services. When using Third Party Services, your security is your responsibility. We don't control Third Party Services, and are not and will not be liable for Third Party Services or for any transaction you may enter into with them, or for what they do. We may receive a revenue share from Third Party Services that we recommend to you or that you otherwise engage via the Services. You agree that we may, at any time and in our sole discretion, and without any notice to you, suspend, disable access to or remove any Third Party Services. We are not and will not be liable for any such suspension, disabling or removal, including without limitation for any loss of profits, revenue, data, goodwill or other intangible losses, or business disruption, costs or expenses you may incur or otherwise experience as a result (except where prohibited by applicable law).</li>
                    
//                     </ol>
//                 </li>
//                 <li style={styles.li}>
//                     <b>Fees.</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}><b style={{background: '#fff'}}>Fees.</b> You can access certain portions and features of the Mobile App/Services by subscribing and selecting Your tier and associated level of payment (such features and services, <b>“Paid Services”</b>). Paid Services will remain in effect until cancelled or terminated in accordance with this Agreement. You may cancel Paid Services at any time through the Apple App Store or Google Play Store..  If you do not make timely payments for the Paid Services, we reserve the right to suspend or cancel your access to the Paid Services/Account. Transaction fees and additional fees may also apply to certain portions of the Services. Our fees are billed through your mobile app store (e.g., Apple Store), unless otherwise indicated. Please note that different tiers of Paid Services have different associated fees.</li>
//                         <li style={styles.li}><b>Taxes.</b> All fees are exclusive of applicable national, provincial, state, local or other taxes <b>(“Taxes”)</b>, unless explicitly stated otherwise. You are and will remain responsible for all applicable Taxes, and we will charge Taxes in addition to the fees for the Services when required to do so. If you are exempt from certain Taxes, you must provide us with valid tax exemption documentation. We reserve the right to determine if the documentation provided is valid. Our application of Tax exemption will only apply from and after the date we receive such valid documentation.</li>
//                         <li style={styles.li}><b>Automatic Subscription Renewals.</b> To ensure uninterrupted Services we will automatically bill you for Your current tier level for Paid Services each month from the date you select Your tier until cancellation or you change Your tier level of subscription. We will automatically charge you the applicable amount through Your mobile app store ((e.g., Apple Store) and by agreeing to this Agreement, you authorize us to do this.</li>
//                         <li style={styles.li}><b>Fee Changes.</b> We may change our fees for any subscription tier level of Paid Services at any time by updating our Subscription Tier Level section. New fees will not apply retroactively. If you do not agree to the change in fees, you may cancel or change subscription tier levels of the applicable Paid Service before your next payment date.  If you do not cancel or change, the new fees will apply to you upon your next monthly payment.</li>
//                         <li style={styles.li}><b>Our Payment Processor.</b> We use third party payment processors (each, a <b>“Payment Processor”</b>) to bill you through a payment account linked to your Account, such as your mobile app store (e.g., Apple Store). The processing of payments will be subject to the terms, conditions and privacy policies of the Payment Processor, in addition to this Agreement.  You agree to pay us, through the Payment Processor, all charges at the prices then in effect for any Paid Services and any purchases in accordance with the applicable payment terms. We reserve the right to 
// correct, or to instruct our Payment Processor to correct, any errors or mistakes, even if payment has already been requested or received.</li>
//                     </ol>
//                 </li>
//                 <li style={styles.li}>
//                     <b>Term; Termination; Effect of Termination.</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}>
//                             <p>The License described in Section (2) (a) above begins when you download the Mobile App and indicate your agreement to the terms of this Agreement, and will continue until it has terminated as follows:</p>
//                             <ol type={'i'}>
//                                 <li style={styles.li}>the License will terminate immediately and automatically without any notice if you terminate this Agreement or otherwise attempt to or revoke your agreement to same;</li>
//                                 <li style={styles.li}>we may terminate the License at any time without notice, for any reason or for no reason, in our sole discretion; or</li>
//                                 <li style={styles.li}>you may terminate the License at any time by uninstalling and making no further use of the Mobile App, provided that the terms of this Agreement shall still apply to your use of the Mobile App that occurred prior to your termination of access/use.</li>
//                             </ol>

//                         </li>
//                         <li style={styles.li}>Upon termination of the License for any reason, you agree to immediately stop accessing or otherwise using the Mobile App and will erase the Mobile App from your Mobile Device. </li>
//                         <li style={styles.li}>The other provisions of this Agreement will continue in full force and effect after termination of the License.  Without limiting the foregoing, termination of the License will not limit our rights or remedies at law or in equity or release you from any claim for breach of the License, liability or other provision of this Agreement that arose before the termination of the License.</li>

//                     </ol>

//                 </li>
//                 <li style={styles.li}>
//                     <b>No Warranty; No Liability for Damages.</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}><i>No Warranty.</i> THE MOBILE APP AND ANY RELATED CONTENT OR MATERIALS ARE PROVIDED “AS IS” AND “AS AVAILABLE”, AND EQUINE EXCHANGE MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT TO ANY OF THE SAME, INCLUDING, WITH RESPECT TO THE MOBILE APP, THAT THE MOBILE APP WILL BE COMPATIBLE OR OTHERWISE WORK WITH ANY DEVICE OR ANY OTHER SOFTWARE, APPLICATIONS, SYSTEMS OR SERVICES, OR IS FIT FOR A PARTICULAR PURPOSE, AND WITH RESPECT TO THE INFORMATION CONTENT, INCLUDING THE ACCURACY OR COMPLETENESS OF SUCH INFORMATION. EQUINE EXCHANGE, ON ITS OWN BEHALF AND ON BEHALF OF ITS AFFILIATES AND ITS AND THEIR RESPECTIVE LICENSORS AND SERVICE PROVIDERS, EXPRESSLY DISCLAIMS THE WARRANTIES OF SATISFACTORY QUALITY, MERCHANTABILITY, NON-INFRINGEMENT, FITNESS FOR ANY PARTICULAR PURPOSE, TITLE, COURSE OF DEALING, AND USAGE IN THE TRADE. THESE DISCLAIMERS ARE AN ESSENTIAL PART OF THIS AGREEMENT. EQUINE EXCHANGE CANNOT AND DOES NOT WARRANT THE MOBILE APP AND RELATED SERVICES WILL ALWAYS BE SECURE OR ERROR-FREE OR THAT THE SERVICES WILL ALWAYS FUNCTION WITHOUT DELAYS, DISRUPTIONS OR IMPERFECTIONS.</li>
//                         <li style={styles.li}><i>No Liability for Damages.</i> TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL EQUINE EXCHANGE, ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE LICENSORS OR SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS AND/OR DIRECTORS, BE LIABLE TO YOU OR ANY OTHER PERSON OR ENTITY FOR: (i) ANY LOST PROFITS, LOSS OF USE, COST OF CURE, DIMINUTION OF VALUE, LOSS OF DATA, OR FOR ANY DIRECT, INCIDENTAL, INDIRECT, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES OF ANY KIND, HOWEVER CAUSED, ARISING OUT OF OR RELATED TO YOUR USE OR MISUSE OF OR INABILITY TO USE THE MOBILE APP, YOUR PURCHASE OF GOODS OR SERVICES IN CONNECTION WITH THE MOBILE APP, OR ANY RELATED INFORMATION, CONTENT OR MATERIALS, INCLUDING YOUR CONTENT, WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR ANY OTHER LEGAL THEORY, EVEN IF THOSE DAMAGES WERE FORESEEABLE AND EVEN IF EQUINE EXCHANGE WAS ADVISED OF THE POSSIBILITY OF THOSE DAMAGES; OR (ii) MONEY DAMAGES, HOWEVER CAUSED, ARISING OUT OF OR RELATED TO THIS AGREEMENT OR TO YOUR USE OR MISUSE OF OR INABILITY TO USE THE MOBILE APP, OR ANY RELATED INFORMATION, CONTENT OR MATERIALS, IN A TOTAL AMOUNT GREATER THAN $10.00 IN THE AGGREGATE.</li>


//                     </ol>

//                 </li>
//                 <li style={styles.li}><b>Choice of Law; Venue; Injunctive Relief.</b>  This Agreement will be interpreted under, and any dispute arising out of this Agreement or the Mobile App will be governed by, the laws of the State of Texas, without reference to its or any other conflict of laws principles. You hereby consent to the exclusive jurisdiction of and venue in the state and federal courts located in Dallas County, Texas, and will not assert any claim against Equine Exchange in any other courts or jurisdictions throughout the world. Any dispute will be limited to the dispute between Equine Exchange and you individually. To the full extent permitted by applicable law, no legal proceeding will be joined with any other person or entity or decided on a class-action basis.  Your breach or threatened breach of this Agreement could cause irreparable injury to Equine Exchange for which money damages alone would be an inadequate remedy. In that case, Equine Exchange will, in addition to its remedies at law, be entitled to temporary or permanent injunctive or other equitable relief against you, without the posting of any bond or other security.</li>
//                 <li style={styles.li}><b>Indemnification.</b> You hereby agree that you (a) will indemnify, defend (at our sole option) and hold harmless, and (b) hereby release and hold harmless Equine Exchange, its affiliates and licensors, and its and their respective officers, directors, members, employees, agents, affiliates, successors and assigns from and against any and all losses, damages, liabilities, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, obligations, costs and/or expenses (including reasonable legal fees) which result from or arise out of your: use or misuse of the Mobile App; use or misuse of any related information, content (including, without limitation, Your Content), materials; related activities; or violation of this Agreement.  Equine Exchange will not represent you in any dispute or arising out of the use of the Mobile App.  We reserve the right to assume control of the defense of any third-party claim that is subject to indemnification by you, in which event you will cooperate with us in asserting any available defenses.  Furthermore, Equine Exchange assumes no responsibility for any goods or Services you purchase or utilize through or in connection with the Mobile App and/or the content you submit or make available through or utilizing the Mobile App, including, without limitation, Your Content.</li>
//                 <li style={styles.li}>
//                     <b>Miscellaneous.</b>
//                     <ol type={'a'}>
//                         <li style={styles.li}><i>Severability.</i>  If any provision of this Agreement is held invalid or unenforceable, in whole or in part, that provision will be modified to the minimum extent necessary to make it valid and enforceable, and the validity and enforceability of all other provisions of this Agreement will not be affected thereby.</li>
//                         <li style={styles.li}><i>Entire Agreement.</i>  This Agreement constitutes the entire agreement between you and Equine Exchange relating to the subject matter of this Agreement, and it supersedes all prior oral and written and contemporaneous oral negotiations, commitments and understandings of the parties.</li>
//                         <li style={styles.li}><i>Amendments.</i>  Equine Exchange may amend this Agreement at any time by posting an updated copy of this Agreement on its website, currently located at [{adminSiteLink}] or by providing notice to you in any other way.  Those amendments will be effective upon notice to you or by your continued use of the Mobile App.  Equine Exchange will not be bound by any amendment to this Agreement unless that amendment is in writing and has been signed by an authorized representative of Equine Exchange.</li>
//                     </ol>
//                 </li>
//                 <li style={styles.li}><b>Contacting Us.</b>  If you have any questions about this Policy, please contact us at equineexchange3@gmail.com</li>
//             </ol>
//         </div>
        
//         <p style={styles.textItalics}>
//             Version: This document was last updated on July 20th, 2021
//         </p>
//         <div
//             style={{
//               display: 'flex',
//               flexDirection: "column",
//               color: COLOR_GREENISH,
//               alignSelf: "center",
//               marginBottom: 20
//             }}>
//             {"\u00A9"} EQUINE EXCHANGE {new Date().getFullYear()}
//         </div>
//       </div>
//     </>
//   );
// }




import React from 'react';
import { Link, useHistory } from "react-router-dom"
// import { COLOR_GREENISH } from '../../utils/constants';
// import styles from './styles'
// import logo from '../../res/logo.png'
// import { Image } from "react-bootstrap"

export default function TermsOfService() {
return (
    <>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <title>Microsoft Word - Phone List - Terms of Use.docx</title>
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html:
        ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .p, p { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; margin:0pt; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s2 { color: #0563C1; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s3 { color: #0563C1; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .a { color: #0563C1; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s4 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .s5 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .s6 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt; }\n #l2> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l3 {padding-left: 0pt; }\n #l3> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l4 {padding-left: 0pt; }\n #l4> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l5 {padding-left: 0pt; }\n #l5> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n'
    }}
  />
  <h1
    style={{
      paddingTop: "3pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    PHONE LIST TERMS OF USE
  </h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    Last Revised February 14, 2022
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    The Phone List application (“App”) is owned and operated by The Talent Match
    Group (“TMG,” “we,” “our,” or “us”). The following Terms of Use (“Terms”)
    govern your access to and use of the Phone List services (“Services”).
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    THESE TERMS CONSTITUTE A BINDING AGREEEMENT BETWEEN YOU AND TMG. YOUR ACCESS
    TO AND USE OF THE APP IS SUBJECT TO THESE TERMS AND ALL APPLICABLE LAWS. WE
    RESERVE THE RIGHT TO TERMINATE YOUR ACCESS TO THE APP IF YOU VIOLATE THESE
    TERMS. BY CLICKING ON LINKS WITHIN THE APP BEYOND THE APP’S HOMEPAGES OR BY
    CLICKING ON A BOX OR ICON YOU AGREE TO THESE TERMS. IF YOU DO NOT AGREE WITH
    THESE TERMS, DO NOT ACCESS OR OTHERWISE USE THE APP, ANY SERVICES AVAILABLE
    THROUGH THE APP, OR ANY INFORMATION CONTAINED ON THE APP.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    THIS AGREEMENT CONTAINS A BINDING ARBITRATION PROVISION WHICH MAY
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    BE ENFORCED BY THE PARTIES. This Agreement requires the use of binding
    arbitration on an individual basis to resolve disputes, rather than jury
    trials or class actions, and also limits the remedies available to you in
    the event of a dispute.
  </p>
  <p
    style={{
      paddingTop: "11pt",
      paddingLeft: "5pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    <span className="p">Besides these Terms, we also publish a </span>
    <span className="s1" style={{ backgroundColor: "#FF0" }}>
      Privacy Policy
    </span>
    <span className="p">
      . Although it is not part of these Terms, we encourage you to read it to
      better understand how you can update, manage, access, and delete your
      information.
    </span>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <ol id="l1">
    <li data-list-text={1}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        USER REGISTRATION
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        We reserve the right to withdraw or amend the App, and any Services we
        provide on the App, in our sole discretion and without notice. We will
        not be liable if, for any reason, all or any part of the App are
        unavailable at any time or for any period. From time to time, in our
        sole discretion and without notice, we may restrict access to some parts
        of the App, or the entire App, to users, including registered users.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        To access the App or certain features of the App, you may be required to
        provide registration details in order to create an account. If so, you
        will choose, or be provided with, a username and password through the
        registration process. You are responsible for keeping your username and
        password confidential. You are responsible for all activities (whether
        by you or by others) that occur under your password and account. You
        agree to notify us immediately of any unauthorized access or use of your
        account. TMG cannot and will not be liable for any loss or damage
        arising from your failure to protect your account information.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        By registering for an account on the App, you represent and warrant that
        your information is true and accurate to the best of your knowledge. You
        agree not to submit false information when registering on the App,
        populating your user profile, or using the App. When registering, you
        must provide your name, phone number, department, position, company name
        and email address. After you register, you may be asked to provide
        additional information.
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        We have the right to disable any username, password, or other
        identifier, whether chosen by you or provided by us, at any time in our
        sole discretion for any reason, including if, in our opinion, you have
        violated any provision of these Terms.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={2}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        PROPRIETARY RIGHTS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        You may not use the contents of the App in any manner or for any purpose
        that would constitute infringement of TMG’s, its licensors’, or the
        App’s other user’s intellectual property rights. TMG may provide
        information, software, photos, videos, text, graphics, and other
        materials (collectively, the “Content”) on the App, and grants you a
        revocable, limited, personal, non-exclusive, and non-transferable
        license to use, view, print, display, and download the Content solely
        for your personal or internal business purposes. Except as otherwise
        provided herein, you may not copy, distribute, or publicly display
        Content for any other purpose or in any other public forum without the
        written consent of TMG or the respective owner, including public forums
        such as other websites, web services, or print publications. TMG or its
        licensors own all trademarks and service marks appearing on the App. The
        unauthorized use or misuse of these trademarks and service marks is
        prohibited.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={3}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        USER DATA
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        During your use of the App and Services, and TMG’s performance of the
        Services, TMG may collect certain content and data relating to your use
        of the App and the Services (“User Data”). You hereby grant to TMG a
        non-exclusive, royalty-free, worldwide, irrevocable, perpetual right and
        license to collect and use such User Data in (i) in order to provide you
        the App and Services,
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        <span className="p">
          (ii) to improve the App and Services and to develop new products and
          services, (iii) for TMG’s own internal research, development, data
          analytics, and marketing purposes, (iv) to create anonymized and
          aggregated data sets for use by TMG and third parties, and (v) for any
          other legitimate business purposes. TMG may use your User Data to
          create anonymized and aggregated data sets for its own use and to
          provide such data sets to affiliates and third parties; provided,
          however, that such data sets be completely de-identified and will not
          contain any personally identifiable information (as defined in the{" "}
        </span>
        <span className="s1" style={{ backgroundColor: "#FF0" }}>
          Privacy Policy
        </span>
        <span className="p">
          ) of any person. TMG treats all personally identifiable information as
          confidential and will maintain such personally identifiable
          information in confidence and prevent its unauthorized use or
          disclosure as set forth in these Terms. Notwithstanding the foregoing,
          TMG may provide User Data to its affiliates and third-party
          contractors as necessary to provide the App and Services to you.
        </span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={4}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        YOUR COMMUNICATIONS TO THE APP
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Except to the extent your content or communications to TMG includes
        personally identifiable information, by forwarding any content or
        communications to TMG through the App or by other electronic means, you
        thereby grant TMG a perpetual, royalty-free, world-wide, irrevocable,
        and non-exclusive license to use, reproduce, modify, adapt, publish,
        translate, create derivative works from, redistribute, and display such
        content and communications in any form for the purposes of providing the
        Services and any purpose tangentially related to the Services. No
        compensation will be paid to you with respect to TMG’s or its
        sublicensees’ use of your communications. By providing or submitting
        content, you represent and warrant that you own or otherwise control all
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        of the rights to your submitted content and communications as described
        in this section including, without limitation, all the rights necessary
        for you to submit the content and communications and grant the license
        above.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={5}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        ELECTRONIC COMMUNICATIONS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        When you use our Services, or send emails, text messages, and other
        communications from your desktop or mobile device to us, you may be
        communicating with us electronically. You consent to receive
        communications from us electronically, such as emails, text messages,
        mobile push notices, or notices and messages on the App, and you can
        retain copies of these communications for your own records. You agree
        that all agreements, notices, disclosures, and other communications that
        we provide to you electronically satisfy any legal requirement that such
        communications be in writing.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={6}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        PROHIBITED ACTIVITIES
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        The following activities are expressly prohibited from the App:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l2">
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Using or submitting any offensive content including, but not limited
            to, obscene language, obscene references, obscene images,
            threatening or harassing messages, discriminatory actions, messages,
            or images, and defamatory statements.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Submitting or posting any false, misleading, or fraudulent
            statements or content.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Engaging in activity that is unauthorized advertisements or
            promotions, including unauthorized solicitation of other users of
            the App.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Collecting personally identifiable information of other users of the
            App and using that information for any purpose outside of the App,
            without that user’s consent.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Engaging in activity that compromises the App. Such activity may
            include, but is not limited to hacking, IP attacks, worms, viruses,
            spamming, phishing, cancel bots, Trojan horses, mail bombing or
            crashing, or introducing malware.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Engaging in any activity designed to impede the use of the App by
            other users, including overloading and flooding.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Framing or deep linking into the App.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Accessing the App by means of automated process, spiders, bots or
            similar device.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={7}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        USER CONTRIBUTIONS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        The App may contain message boards, chat rooms, personal web pages,
        profiles, or menus, forums, bulletin boards, and other interactive
        features (collectively, “Interactive Services”) that allow users to
        post, submit, publish, display, or transmit to other users or other
        persons (hereinafter, “post”) content or materials (collectively, “User
        Contributions”) on or through the App or Services.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        All User Contributions must comply with the Content Standards set out in
        these Terms.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Any User Contribution you post to the App or through the Services will
        be considered non-confidential and non-proprietary. By providing any
        User Contribution on the App, you grant us and our service providers,
        and each of their and our respective licensees, successors, and assigns
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        the right to use, reproduce, modify, perform, display, distribute, and
        otherwise disclose to third parties any such material for any purpose.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        You represent and warrant that:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l3">
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            You own or control all rights in and to the User Contributions and
            have the right to grant the license granted above to us and our
            service providers, and each of their and our respective licensees,
            successors, and assigns.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            All of your User Contributions do and will comply with these Terms.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            You understand and acknowledge that you are responsible for any User
            Contributions you submit or contribute, and you, not TMG, have full
            responsibility for such content, including its legality,
            reliability, accuracy, and appropriateness. This includes any menu
            prices or other items that you may use the Services to create or
            display to users.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            We are not responsible or liable to any third party for the content
            or accuracy of any User Contributions posted by you or any other
            user of the App.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={8}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        MONITORING AND ENFORCEMENT; TERMINATION
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        We have the right to:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l4">
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Remove or refuse to post any User Contributions for any or no reason
            in our sole discretion.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Take any action with respect to any User Contribution that we deem
            necessary or appropriate in our sole discretion, including if we
            believe that such User Contribution violates the Terms, including
            the Content Standards, infringes any intellectual property right or
            other right of any person or entity, threatens the personal safety
            of users of the App or the public, or could create liability for us.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Disclose your identity or other information about you to any third
            party who claims that material posted by you violates their rights,
            including their intellectual property rights or their right to
            privacy.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Take appropriate legal action, including referral to law
            enforcement, for any illegal or unauthorized use of the App.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Terminate or suspend your access to all or part of the App for any
            reason, including any violation of these Terms.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Without limiting the foregoing, we have the right to cooperate fully
            with any law enforcement authorities or court order requesting or
            directing us to disclose the identity or other information of anyone
            posting any materials on or through the App. YOU WAIVE AND HOLD
            HARMLESS TMG AND ITS AFFILIATES, LICENSEES, AND SERVICE PROVIDERS
            FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY ANY OF THE
            FOREGOING PARTIES DURING, OR TAKEN AS A CONSEQUENCE OF,
            INVESTIGATIONS BY EITHER SUCH PARTIES OR LAW ENFORCEMENT
            AUTHORITIES.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            However, we cannot review all material before it is posted on the
            App or sent through the Services and cannot ensure prompt removal of
            objectionable material after it has been posted or sent.
            Accordingly, we assume no liability for any action or inaction
            regarding transmissions,
          </p>
          <p
            style={{
              paddingTop: "3pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            communications, or content provided by any user or third party. We
            have no liability or responsibility to anyone for performance or
            nonperformance of the activities described in this section.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={9}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        CONTENT STANDARDS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        These content standards apply to any and all User Contributions and use
        of the Services. User Contributions must in their entirety comply with
        all applicable federal, state, local, and international laws and
        regulations. Without limiting the foregoing, User Contributions must
        not:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l5">
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Contain any material that is defamatory, obscene, indecent, abusive,
            offensive, harassing, violent, hateful, inflammatory, or otherwise
            objectionable.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Promote sexually explicit or pornographic material, violence, or
            discrimination based on race, sex, religion, nationality,
            disability, sexual orientation, or age.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Infringe any patent, trademark, trade secret, copyright, or other
            intellectual property or other rights of any other person.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Violate the legal rights (including the rights of publicity and
            privacy) of others or contain any material that could give rise to
            any civil or criminal liability under applicable laws or regulations
            or that otherwise may be in conflict with these Terms and our
            Privacy Policy.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Be likely to deceive any person.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              lineHeight: "15pt",
              textAlign: "justify"
            }}
          >
            Promote any illegal activity, or advocate, promote, or assist any
            unlawful act.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Cause annoyance, inconvenience, or needless anxiety or be likely to
            upset, embarrass, alarm, or annoy any other person.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Impersonate any person or misrepresent your identity or affiliation
            with any person or organization.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Involve commercial activities or sales, such as contests,
            sweepstakes, and other sales promotions, barter, or advertising.
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Give the impression that they emanate from or are endorsed by us or
            any other person or entity, if this is not the case.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={10}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        APP STORES
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s2"
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        <span className="p">
          You acknowledge and agree that the availability of the App may be
          dependent on the third party from which you received the App’s
          license, e.g., the Apple iPhone or Android app stores (“App Store”).
          You acknowledge and agree that these Terms are between you and TMG and
          not with the App Store and that TMG is responsible for the provision
          of Services as described in these Terms. However, if you downloaded
          the App from the Apple App Store, Apple and its subsidiaries are
          third-party beneficiaries of these Terms. Upon your acceptance of
          these Terms, Apple shall have the right (and will be deemed to have
          accepted the right) to enforce these Terms against you as a
          third-party beneficiary thereof. These Terms incorporate by reference{" "}
        </span>
        Apple’s Licensed<span className="s3"> </span>Application End User
        License Agreement
        <span className="p">
          , for purposes of which, you are “the end-user.” In the event of a
          conflict in the terms of the Licensed Application End User License
          Agreement and these Terms, these Terms will control.
        </span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={11}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        THIRD PARTY LINKS
      </h1>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        The App may contain links to other third-party websites. Such
        third-party websites are maintained by persons or organizations over
        which TMG exercises no control. Your use of these third-party websites
        is governed by the terms of use and privacy policy of such websites. TMG
        expressly disclaims any responsibility for the content or results from
        your use of such third-party websites.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={12}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        INJUNCTIVE RELIEF
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        You acknowledge that we may be irreparably damaged if these Terms are
        not specifically enforced, and damages at law would be an inadequate
        remedy. Therefore, in the event of a breach or threatened breach of any
        provision of these Terms by you, we shall be entitled, without prejudice
        to any other rights and remedies that may be sought under Section 13, to
        an injunction restraining such breach or threatened breach, without
        being required to show any actual damage or to post an injunction bond,
        and/or to a decree for specific performance of the provisions of these
        Terms. For purposes of this Section, you agree that any action or
        proceeding with regard to such injunction restraining such breach or
        threatened breach shall be brought in the state or federal courts
        located in Texas. You consent to the jurisdiction of such court and
        waive any objection to the laying of venue of any such action or
        proceeding in such court. You agree that service of any court paper may
        be effected on such party by mail or in such other manner as may be
        provided under applicable laws, rules of procedure or local rules.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={13}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        MANDATORY ARBITRATION AND CLASS ACTION AND JURY TRIAL WAIVER
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Most concerns can be resolved quickly and to your satisfaction by
        contacting us as set forth in the “Questions” section below.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        In the event that we are not able to resolve a dispute, and with the
        exception of the claims for injunctive relief by us as described above,
        you hereby agree that either you or we may require any dispute, claim,
        or cause of action (“Claim”) between you and us or any third parties
        arising out of use of the App, the Services, and any other actions with
        us (whether based in contract, tort, statute, fraud, misrepresentation,
        or any other legal theory) to be arbitrated on an individual (non-class)
        basis. However, both parties retain the right to seek relief in a small
        claims court (or a state court equivalent) for a Claim within the scope
        of its jurisdiction so long as the small claims action does not seek to
        certify a class, combine the claims of multiple persons, recover damages
        in excess of the limit for a small claim under applicable state law or
        is not transferred, removed, or appealed from small claims court to any
        different court. Additionally, if you are a California resident, you
        retain the right to obtain public injunctive relief from any court with
        proper jurisdiction.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h1
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        THERE IS NO JUDGE OR JURY IN ARBITRATION, AND COURT REVIEW OF AN
        ARBITRATION AWARD IS VERY LIMITED. ADDITIONALLY, ANY ARBITRATION OF A
        CLAIM WILL BE ON AN INDIVIDUAL BASIS, AND, THEREFORE, YOU UNDERSTAND AND
        AGREE THAT YOU ARE WAIVING THE RIGHT TO PARTICIPATE AS A CLASS
        REPRESENTATIVE OR CLASS MEMBER IN A CLASS ACTION LAWSUIT. AS PART OF
        THIS WAIVER, YOU AGREE THAT YOU WAIVE THE RIGHT TO ACT AS A PRIVATE
        ATTORNEY GENERAL IN AN ARBITRATION; THAT EXCEPT AS OTHERWISE PROVIDED IN
        THIS ARBITRATION AGREEMENT, CLAIMS BROUGHT BY OR AGAINST YOU MAY NOT BE
        JOINED OR CONSOLIDATED WITH CLAIMS BROUGHT BY OR AGAINST ANY OTHER
      </h1>
      <h1
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        PERSON; AND THE ARBITRATOR SHALL HAVE NO AUTHORITY TO CONDUCT A
        CLASS-WIDE ARBITRATION, PRIVATE ATTORNEY GENERAL ARBITRATION OR
        MULTIPLE-PARTY ARBITRATION.
      </h1>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        You and we agree that your use of the Services involves interstate
        commerce, and that this arbitration agreement shall be interpreted and
        enforced in accordance with the Federal Arbitration Act (FAA) set forth
        in Title 9 of the U.S. Code to the fullest extent possible,
        notwithstanding any state law to the contrary, regardless of the origin
        or nature of the Claims at issue. The arbitrator must follow, to the
        extent applicable: (1) the substantive law of the state in which we
        entered into the transaction giving rise to this arbitration agreement;
        (2) the applicable statutes of limitations; and (3) claims of privilege
        recognized at law. The arbitrator will not be bound by federal, state or
        local rules of procedure and evidence or by state or local laws
        concerning arbitration proceedings.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        If either you or we elect to arbitrate a Claim, the dispute shall be
        resolved by binding arbitration administered under the applicable rules
        of the American Arbitration Association (“AAA”). Either you or we may
        elect to resolve a particular Claim through arbitration, even if the
        other party has already initiated litigation in court related to the
        Claim, by: (a) making written demand for arbitration upon the other
        party, (b) initiating arbitration against the other party, or (c) filing
        a motion to compel arbitration in court.
      </p>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        If this is a consumer-purpose transaction, the applicable rules will be
        the AAA’s Consumer Arbitration Rules. The applicable AAA rules and other
        information about arbitrating a claim under AAA, including how to submit
        a dispute to arbitration, may be obtained by visiting its website at{" "}
        <a href="http://www.adr.org/" className="a" target="_blank">
          https://
        </a>
        <span className="s2">www.adr.org/</span> or by calling 1-800-778-7879.
        If AAA will not serve as the administrator of the arbitration, and you
        and we cannot then agree upon a substitute arbitrator, you and we shall
        request that a court with proper jurisdiction appoint an arbitrator.
        However, we will abide by the applicable AAA rules regardless of the
        forum. Arbitration shall be conducted in the county and state where you
        accepted these Terms, you reside, or another reasonably convenient place
        to you as determined by the arbitrator, unless applicable laws require
        another location. Judgment on the award rendered by the arbitrator may
        be entered in any court having jurisdiction thereof. Except as provided
        in applicable statutes, the arbitrator’s award is not subject to review
        by the court and it cannot be appealed. The parties will have the option
        to request and receive a statement of reasons for the arbitration award.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        If you elect to file the arbitration, and this is a consumer-purpose
        transaction, you will pay the filing fee to the extent required by AAA’s
        Consumer Arbitration Rules but not to exceed the cost of filing a
        lawsuit. Any amount above what it would cost you to file a lawsuit, we
        will pay. All other arbitration fees and expenses shall be allocated to
        us according to AAA rules. Except for the arbitration fees and expenses,
        each party shall pay its own costs and fees incurred (including
        attorneys’ fees), unless the arbitrator allocates them differently in
        accordance with applicable law. This paragraph applies only if this is a
        consumer-purpose transaction.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Notwithstanding anything to the contrary in these Terms, and except as
        otherwise set forth in this paragraph, the agreement to arbitration may
        be amended by us only upon advance notice to you. If we make any
        amendment to this agreement to arbitration (other than renumbering the
        agreement to align with any other amendment to the Terms) in the future,
        that amendment shall not apply to any claim that was filed in a legal
        proceeding or action against us prior to the effective date of the
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        amendment. The amendment shall apply to all other Claims governed by
        this agreement to arbitration that have arisen or may arise between you
        and us. However, we may amend this agreement to arbitration and not
        provide you notice; in that case, the amendments will not apply to you
        and the agreement to arbitration contained in these Terms to which you
        agreed will continue to apply to you and us as if no amendments were
        made.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        If any part of this arbitration provision is invalid, all other parts of
        it remain valid. However, if the class action limitation is invalid,
        then this arbitration provision is invalid in its entirety, provided
        that the remaining Terms shall remain in full force and effect. This
        arbitration provision will survive the termination of your use of the
        App, the Services, and any other actions with us.
      </p>
      <h1
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        <a href="mailto:admin@phone-list.com" className="s4" target="_blank">
          You may reject this arbitration provision within thirty (30) days of
          accepting the Terms by emailing us at{" "}
        </a>
        admin@phone-list.com and including in the subject line “Rejection of
        Arbitration Provision.”
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={14}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        FEDERAL AND STATE LAWS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        The App is operated from the United States. When using the App, on the
        App, or when using any Services provided by TMG, you must obey all
        applicable U.S.-based federal, state, and local laws.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={15}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        MINIMUM AGE
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        We do not allow persons under the age of sixteen (16) to use the App. By
        using the App, you represent and warrant that you are sixteen (16) years
        of age or over.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={16}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        DISCLAIMER OF WARRANTIES
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        TO THE FULLEST EXTENT PROVIDED BY LAW AND EXCEPT AS OTHERWISE PROVIDED
        HEREIN OR ON THE APP, THE INFORMATION AND SERVICES OFFERED ON OR THROUGH
        THE APP AND ANY REFERENCED THIRD-PARTY SITES ARE PROVIDED “AS IS” AND
        WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. ANY
        THIRD-PARTY GOODS OR SERVICES PROVIDED ARE SUPPLIED AS A CONVENIENCE TO
        YOU AND DO NOT CONSTITUTE SPONSORSHIP, AFFILIATION, PARTNERSHIP, OR
        ENDORSEMENT. TO THE FULLEST EXTENT ALLOWED BY LAW, WE DISCLAIM ALL
        EXPRESS AND IMPLIED WARRANTIES, INCLUDING THE IMPLIED WARRANTY OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
        NON-INFRINGEMENT.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        TO THE FULLEST EXTENT ALLOWED BY LAW, WE DO NOT WARRANT OR MAKE ANY
        REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE USE OF THE APP,
        THE CONTENT, THE SERVICES, OR OTHER POSTED MATERIALS ON THE APP IN TERMS
        OF ITS CORRECTNESS, ACCURACY, TIMELINESS, RELIABILITY OR OTHERWISE. BY
        PROVIDING THE SERVICES ON THE APP, WE DO NOT IN ANY WAY PROMISE THAT THE
        SERVICES WILL REMAIN AVAILABLE TO YOU. WE ARE ENTITLED TO TERMINATE ALL
        OR PART OF ANY OF THE APP AT ANY TIME, IN OUR SOLE DISCRETION WITHOUT
        NOTICE TO YOU.
      </p>
    </li>
    <li data-list-text={17}>
      <h1
        style={{
          paddingTop: "3pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        LIMITATION OF LIABILITY
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        WE CANNOT GUARANTEE THE APP WILL BE AVAILABLE ONE HUNDRED PERCENT (100%)
        OF THE TIME BECAUSE PUBLIC NETWORKS, SUCH AS THE INTERNET, OCCASSIONALLY
        EXPERIENCE DISRUPTIONS. ALTHOUGH WE STRIVE TO PROVIDE THE MOST RELIABLE
        APP REASONABLY POSSIBLE, INTERRUPTIONS AND DELAYS IN ACCESSING THE APP
        ARE UNAVOIDABLE AND WE DISCLAIM ANY LIABILITY FOR DAMAGES RESULTING FROM
        SUCH PROBLEMS.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        NOTWITHSTANDING THE FOREGOING, THE LIABILITY OF TMG AND ITS AFFILIATES,
        EMPLOYEES, AGENTS, REPRESENTATIVES AND THIRD-PARTY SERVICE PROVIDERS
        WITH RESPECT TO ANY AND ALL CLAIMS ARISING OUT OF YOUR USE OF THE APP,
        THE CONTENT, OR SERVICES OBTAINED THROUGH THE APP, WHETHER BASED ON
        WARRANTY, CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, SHALL NOT
        EXCEED FIFTY DOLLARS ($50).
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        IN NO EVENT WILL WE BE LIABLE TO YOU OR ANY PARTY FOR ANY DIRECT,
        INDIRECT, SPECIAL OR OTHER CONSEQUENTIAL DAMAGES FOR ANY USE OF THE APP,
        OR ON ANY OTHER HYPERLINKED WEBSITES, INCLUDING, WITHOUT LIMITATION, ANY
        LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR OTHER DATA OR
        OTHERWISE, EVEN IF WE ARE EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH
        DAMAGES.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={18}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        INDEMNIFICATION
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        You agree to indemnify, defend and hold harmless TMG and its affiliates,
        employees, agents, representatives and third-party service providers,
        for any and all claims, demands, actions, liability, fines, penalties
        and expenses that may arise from any of your acts through the use of the
        App. Such acts may include, but are not limited to, (i) your User
        Contributions, (ii) any misuse of the App and Services, (iii) providing
        content to or communicating with us or our affiliates, (iv) unauthorized
        use of material obtained through the App, (v) engaging in a prohibited
        activity, or
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        (vi) any other action that breaches these Terms.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={19}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        COPYRIGHT COMPLAINTS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        TMG respects the intellectual property of others. If you believe that
        your work has been copied in a way that constitutes copyright
        infringement, please contact TMG through the contact information
        provided in these Terms.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={20}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        MISCELLANEOUS PROVISIONS
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s5"
        style={{ paddingLeft: "5pt", textIndent: "18pt", textAlign: "justify" }}
      >
        Severability
        <span className="p">
          . If any term or provision in these Terms is found to be void, against
          public policy, or unenforceable by a court of competent jurisdiction
          and such finding or order becomes final with all appeals exhausted,
          then the offending provision shall be deemed modified to the extent
          necessary to make it valid and enforceable. If the offending provision
          cannot be so modified, then
        </span>
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        the same shall be deemed stricken from these Terms in its entirety and
        the remainder of these Terms shall survive with the said offending
        provision eliminated.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s5"
        style={{ paddingLeft: "5pt", textIndent: "18pt", textAlign: "justify" }}
      >
        Typographical Errors
        <span className="p">
          . Information on the App may contain technical inaccuracies or
          typographical errors. We attempt to make the App’s postings as
          accurate as possible, but we do not warrant that the content of the
          App is accurate, complete, reliable, current, or error-free.
        </span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s5"
        style={{ paddingLeft: "5pt", textIndent: "18pt", textAlign: "justify" }}
      >
        Headings
        <span className="p">
          . Condition and section headings are for convenience of reference only
          and shall not affect the interpretation of these Terms.
        </span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s5"
        style={{ paddingLeft: "5pt", textIndent: "18pt", textAlign: "justify" }}
      >
        Controlling Law and Venue
        <span className="p">
          . It is understood and agreed that all the construction and
          interpretation of these Terms and the relationship between the parties
          shall at all times and in all respects be governed by the internal
          laws of the State of Texas, without giving effect to the conflict of
          laws provisions thereof. Except as set forth in the agreement to
          arbitration and without waiving it, you agree that any dispute arising
          from or relating to the subject matter of these Terms (including but
          not limited to if you opt out of the agreement to arbitration) shall
          be governed by the exclusive jurisdiction and venue of the state and
          federal courts of Austin, Texas, except where the jurisdiction and
          venue are mandated by applicable assignment
        </span>
        <span className="s6">.</span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s5"
        style={{ paddingLeft: "5pt", textIndent: "18pt", textAlign: "justify" }}
      >
        No Waiver.{" "}
        <span className="p">
          No failure, omission or delay on the part of TMG in exercising any
          right under these Terms will preclude any other further exercise of
          that right or other right under these Terms.
        </span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={21}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        QUESTIONS
      </h1>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s2"
    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
  >
    <a
      href="mailto:admin@phone-list.com"
      style={{
        color: "black",
        fontFamily: '"Times New Roman", serif',
        fontStyle: "normal",
        fontWeight: "normal",
        textDecoration: "none",
        fontSize: "12pt"
      }}
      target="_blank"
    >
      If you have any questions or comments about these Terms or this App,
      please contact us by email at{" "}
    </a>
    admin@phone-list.com<span className="s3"> </span>
    <span className="p">or call us at 806-503-4012.</span>
  </p>
</>

)
}